module.exports = __webpack_public_path__ + "static/common-sense-on-mutual-funds-a1652ca88306e13f0bfb8d5b9f049a1d.jpg";